import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { UserData } from '../../classes/user-data.class';
import * as firebase from 'firebase';

@Component({
  selector: 'app-dialog-edit-Profile',
  templateUrl: '../../templates/dialogs/dialog-edit-profile.component.html'
})

export class DialogEditProfileComponent implements OnInit {

  validForm = false;

  UserData = new UserData();
  image: string;
  constructor(public userService: UserService) {

    // Hier kry ons eers n reference na die file toe wat ons soek
    let storage = firebase.storage();
    let storageRef = storage.ref();
    let imagesRef = storageRef.child('profile');

    let profilePictureRef = storageRef.child('profile/'+ this.userService.getCurrentUserId() +'/profile.jpg'); // Hierdie user se profile image
    let path = profilePictureRef.fullPath
    let name = profilePictureRef.name
    profilePictureRef.getDownloadURL().then(url => this.image = url); // Hier kry ons die src van die image.
   }

  ngOnInit() {
  
     // this.UserData = this.userService.getUserData();
  
  }


  updateProfile() {
    this.userService.updateUserDataValues(this.UserData);
  }

  uploadProfileImage(){
    
  }
}


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/components/dialogs/dialog-edit-profile.component.ts